import { DeleteMenuData, MenuService } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useDeleteNavigation(
  mutationOptions?: UseMutationOptions<void, HttpError, DeleteMenuData>,
) {
  return useMutation({
    mutationFn: MenuService.deleteMenu,
    ...mutationOptions,
  });
}

export { useDeleteNavigation };
